module.exports = __webpack_public_path__ + "static/media/expand_base.23b48e91.svg";